/**
 * Who sees the teacher tabs (v3.79.0) — extracted verbatim from App.js
 * SidePanel so the Reports gate (reportsGate.js) and the sidebar can never
 * disagree. Pure refactor, pinned for every role combination by
 * teacherTabs.test.js.
 *
 * Admits: teacher, EA, teacher/EA + admin, teacher/EA + TLS, and accounts
 * with NO role claim at all (legacy users — they see Results, so they see the
 * Class Report: same data, same reads).
 * Excludes: pure global admin, pure district admin, pure TLS.
 */
export function showsTeacherTabs(role) {
  const isTeacherOrEA = !!(role?.teacher || role?.ea);
  const isPureAdmin = !!(role?.admin || role?.districtAdmin) && !isTeacherOrEA;
  const isPureTLS = !!role?.tls && !isTeacherOrEA && !role?.admin && !role?.districtAdmin;
  return !isPureAdmin && !isPureTLS;
}
